import React, { useEffect } from "react";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function PrerequisitesForPractical({ templateName }: { templateName: string }) {
    const user = useAppSelector(getUser)
    const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
    const [issuance, setIssuance] = React.useState("")
    const dispatch = useDispatch()
    useEffect(() => {
        const templateText = `I certified that ${name} has received and logged training time within 2 calendar-months preceding the month of application in  preparation for the e practical test and [he or she] is prepared for the required practical test for the issuance of ${issuance}`
        dispatch(setTemplateText(templateText))
    }, [name, issuance, dispatch])
    return (
        <TemplateLayout templateName={templateName}>
            <div className="col-12 my-2">
                <label>Relevant FAR: 61.160</label>
            </div>

            <div className="col-12 my-2">
                <p className="certificate_text">
                    I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received and logged training time within 2 calendar-months preceding the month of application in  preparation for the e practical test and [he or she] is prepared for the required practical test for the issuance of <input type="text" onChange={(e) => setIssuance(e.target.value)} />
                </p>
            </div>
        </TemplateLayout>
    );
}

export default PrerequisitesForPractical;
